import type { AudioDeviceOption } from './audioDevices.ts';

/**
 * The devices as a picker lists them.
 *
 * A device the browser will not name yet is still a device that can be chosen —
 * numbered, because "Microfoon" three times over is a list nobody can use. The
 * words come from the screen; the numbering is the same wherever the question
 * is asked.
 */
export function audioDeviceOptions(
  devices: AudioDeviceOption[],
  unnamed: (index: number) => string,
): { value: string; label: string }[] {
  return devices.map((device, index) => ({
    value: device.id,
    label: device.label || unnamed(index + 1),
  }));
}
